// auto-generated by Typewriter template _enums.tst from PortCall.Models\CoordinationCards\CoordinationLocation.cs
export enum CoordinationLocationType { 
    Main = 0,
    Related = 10
}

export const CoordinationLocationTypeDisplayName : { [val : number] : string } = { 
    0: 'Main',
    10: 'Related'
}

export const CoordinationLocationTypes : { Id : CoordinationLocationType, Name : string }[] = [ 
    { Id: CoordinationLocationType.Main, Name: 'Main' },
    { Id: CoordinationLocationType.Related, Name: 'Related' }
]



// WEBPACK FOOTER //
// ./server/enums/CoordinationLocationType.ts